import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Renders children into document.body so `position: fixed` is relative to
// the viewport, not any transformed/animated ancestor (e.g. `.fade-in`).
export default function Portal({ children }) {
  const [container] = useState(() => {
    if (typeof document === "undefined") return null;
    const el = document.createElement("div");
    el.setAttribute("data-portal", "teak-studio");
    return el;
  });

  useEffect(() => {
    if (!container) return;
    document.body.appendChild(container);
    return () => {
      if (container.parentNode) container.parentNode.removeChild(container);
    };
  }, [container]);

  if (!container) return null;
  return createPortal(children, container);
}
